import { render, staticRenderFns } from "./SpiderPage.vue?vue&type=template&id=0b2e4cdf&"
import script from "./SpiderPage.vue?vue&type=script&lang=js&"
export * from "./SpiderPage.vue?vue&type=script&lang=js&"
import style0 from "./SpiderPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports